import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialFileError: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.05 32h25.9V7.62h-1.52V6.1h-1.52V4.57h-1.53V3.05h-1.52V1.52h-1.53V0H3.05ZM4.57 1.52h15.24v7.62h7.62v21.34H4.57Z\"/><path fill=\"currentColor\" d=\"M7.62 19.81v1.52h10.67v3.05h1.52v-3.05h3.05v3.05h1.52v-4.57zm15.24-7.62h-1.53v1.52h-1.52v1.53h1.52v1.52h1.53v-1.52h1.52v-1.53h-1.52zm-3.05 12.19h3.05v1.52h-3.05ZM9.14 16.76h1.53v-1.52h1.52v-1.53h-1.52v-1.52H9.14v1.52H7.62v1.53h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialFileError
